import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const COMPANY_BUILDINGS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'buildingId',
        field: 'buildingId',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/buildings-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'buildingName',
        field: 'buildingName',
        headerName: 'Name',
        cellDataType: 'text'
    },
    {
        colId: 'addressLines',
        field: 'addressLines',
        headerName: 'Address',
        cellDataType: 'text',
        sortable: false
    },
    {
        colId: 'cityName',
        field: 'cityName',
        headerName: 'City',
        cellDataType: 'text'
    },
    {
        colId: 'stateName',
        field: 'stateName',
        headerName: 'State',
        cellDataType: 'text'
    },
    {
        colId: 'countryName',
        field: 'countryName',
        headerName: 'Country',
        cellDataType: 'text'
    },
    {
        colId: 'isMain',
        field: 'isMain',
        headerName: 'Main Office',
        width: 150,
        sortable: false,
        filter: false,
        suppressHeaderMenuButton: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                return '<span class="badgeMain primaryColor">Main Office</span>';
            }
            return '';
        }
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
